import { EXPORT_TYPES } from '@Services/ExportService/ExportConstants';

const createActionsTypes = (exportType) => {
  return {
    exportTabSetExportTypeReducerType: `${exportType}SetExportTypeReducerType`,
    exportTabSetExportResultReducerType: `${exportType}SetExportResultReducerType`,
    exportTabSetTooltipModalOpenedReducerType: `${exportType}SetTooltipModalOpenedReducerType`,
    exportTabSetDownloadUrlReducerType: `${exportType}SetDownloadUrlReducerType`,
    exportTabSetRetryDisabledReducerType: `${exportType}SetRetryDisabledReducerType`,
    exportTabSetCancelledJobIdsReducerType: `${exportType}SetCancelledJobIdsReducerType`,
  };
};

const createReducerKey = (exportType) => `${exportType}ReducerKey`;

export const exportTabReducerKey = createReducerKey(EXPORT_TYPES.GENERIC);
export const chemQuoteExportTabReducerKey = createReducerKey(EXPORT_TYPES.CHEMQUOTE);

export const exportTabActionsTypes = createActionsTypes(EXPORT_TYPES.GENERIC);
export const chemQuoteExportTabActionsTypes = createActionsTypes(EXPORT_TYPES.CHEMQUOTE);

export const EXPORT_TAB_RESULT_STATUSES = {
  STARTED: 'started',
  FINISHED: 'finished',
  CONNECTION_ERROR: 'connection-error',
  RUNNING: 'running',
};
